import './Loading.styles.scss';

import { ProgressSpinner } from 'primereact/progressspinner';
import { FC } from 'react';

export const Loading: FC = () => (
  <div id="Loading-Component">
    <div className="loader">
      <ProgressSpinner />
    </div>
  </div>
);
